import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const getDeviceUUID = async () => {
    let id = localStorage.getItem("fingerprintId");
    if (!id) {
        id = await getDeviceFingerprintId(); // modern browsers
        localStorage.setItem("fingerprintId", id);
    }
    return id;
};


export async function getDeviceFingerprintId() {
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();
    return visitorId;
}